/**
 * 创建人：zll
 * 时间：2020-12-16
 * 描述：筛选查询组件
 * 使用说明: 参考 sw-filter-search 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, HostListener, ElementRef, ContentChild, TemplateRef, ViewChild } from '@angular/core';
declare var $: any;


/**
 * 按钮工具栏 筛选查询组件 sw-filter-search
 */
@Component({
  selector: 'sw-filter-search',
  templateUrl: './sw-filter-search.component.html',
  styleUrls: ['./sw-filter-search.component.css']
})
export class SwFilterSearchComponent implements OnInit, AfterViewInit {

  /**
    * 查询条件放在按钮栏內 且选择的样式为2的查询数据
    * @ignore
    */
  @ContentChild('filterSearch') filterSearchTmpl: TemplateRef<any>;

  /**
   * 打开选择样式2
   * @ignore
   */
  drownDownBox2: boolean = false;
  /**
   * 筛选查询的宽度，可自定义，默认值为313px
   */
  @Input() filterSearchWidth: string = '313px';
  show: boolean = false;
  /**
  * 隐藏时的定位
  * @ignore 
  */
  top: string = '10px'
  @ViewChild("searchDropdown") searchDropdown: ElementRef;  //筛选组件
  /**
   * @ignore
   */
  constructor(private _elementRef: ElementRef) { }

  /**
   * @ignore
   */
  ngOnInit() {
  }
  /**
     * 打开查询数据样式2盒子 
     * @ignore
     */
  openBox2() {
    this.drownDownBox2 = !this.drownDownBox2;
    //若为true 表示显示右侧盒子
    if (this.drownDownBox2) {
      this.show = true;
      setTimeout(() => {
        this.top = '40px'
      }, 0)
    } else {
      //若为false 隐藏该盒子
      this.top = '10px'
      setTimeout(() => {
        this.show = false;
      }, 300)
    }
  }
  /**
    * 关闭查询数据样式2盒子
    * @ignore
    */
  clickToClose() {
    this.drownDownBox2 = false;
    this.top = '10px'
    setTimeout(() => {
      this.show = false;
    }, 300)

  }
  /**
   * @ignore
   */
  ngAfterViewInit() {
  }

  //监听查询2事件 以外隐藏
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (this.show) {
      const clickInside = this.searchDropdown.nativeElement.contains(targetElement); //是否在筛选查询盒子內
      const clickInsideWrapper = document.getElementsByClassName('wrapper')[0].contains(targetElement); //是否在wrapper盒子內
      if (clickInsideWrapper && !clickInside) {
        this.clickToClose()
      }
    }
  }
}
